var map = {
	"./Dictionary.ts": "./src/Dictionary.ts",
	"./UCWindow.ts": "./src/UCWindow.ts",
	"./cart/CartError.ts": "./src/cart/CartError.ts",
	"./cart/CartItem.ts": "./src/cart/CartItem.ts",
	"./cart/CartProcessor.ts": "./src/cart/CartProcessor.ts",
	"./cart/TCartItems.ts": "./src/cart/TCartItems.ts",
	"./catalog/Catalog.ts": "./src/catalog/Catalog.ts",
	"./common/ComboBox.ts": "./src/common/ComboBox.ts",
	"./common/IComboBoxData.ts": "./src/common/IComboBoxData.ts",
	"./common/NumberUtils.ts": "./src/common/NumberUtils.ts",
	"./common/PrestaGlobals.ts": "./src/common/PrestaGlobals.ts",
	"./config/cdn.ts": "./src/config/cdn.ts",
	"./database/Boards.ts": "./src/database/Boards.ts",
	"./database/Edges.ts": "./src/database/Edges.ts",
	"./database/Fetcher.ts": "./src/database/Fetcher.ts",
	"./database/IBoardData.ts": "./src/database/IBoardData.ts",
	"./database/IEdgeData.ts": "./src/database/IEdgeData.ts",
	"./database/IParamScriptsRule.ts": "./src/database/IParamScriptsRule.ts",
	"./dbmap/clusters.ts": "./src/dbmap/clusters.ts",
	"./dbmap/graphLayout.ts": "./src/dbmap/graphLayout.ts",
	"./dbmap/types.ts": "./src/dbmap/types.ts",
	"./dbmap/useSchema.ts": "./src/dbmap/useSchema.ts",
	"./designer/ICabinetResult.ts": "./src/designer/ICabinetResult.ts",
	"./designer/IOrder.ts": "./src/designer/IOrder.ts",
	"./designer/UnityHandler.ts": "./src/designer/UnityHandler.ts",
	"./material_catalog/api.ts": "./src/material_catalog/api.ts",
	"./material_catalog/colors.ts": "./src/material_catalog/colors.ts",
	"./material_catalog/images.ts": "./src/material_catalog/images.ts",
	"./material_catalog/types.ts": "./src/material_catalog/types.ts",
	"./paramScript/MaterialConfigurator.ts": "./src/paramScript/MaterialConfigurator.ts",
	"./paramScript/NameConfigurator.ts": "./src/paramScript/NameConfigurator.ts",
	"./paramScript/ParamScriptsProcessor.ts": "./src/paramScript/ParamScriptsProcessor.ts",
	"./paramScript/SizeConfigurator.ts": "./src/paramScript/SizeConfigurator.ts",
	"./site.ts": "./src/site.ts",
	"./ucsmartquote/boards.ts": "./src/ucsmartquote/boards.ts",
	"./v2/admin/lineDiff.ts": "./src/v2/admin/lineDiff.ts",
	"./v2/admin/paramUtils.ts": "./src/v2/admin/paramUtils.ts",
	"./v2/admin/scriptFiles.ts": "./src/v2/admin/scriptFiles.ts",
	"./v2/aiDesigner/designerDriver.ts": "./src/v2/aiDesigner/designerDriver.ts",
	"./v2/common/NameUtils.ts": "./src/v2/common/NameUtils.ts",
	"./v2/common/download.ts": "./src/v2/common/download.ts",
	"./v2/common/inputs/unitConfig.ts": "./src/v2/common/inputs/unitConfig.ts",
	"./v2/configurator/cards/backPassingRelations.ts": "./src/v2/configurator/cards/backPassingRelations.ts",
	"./v2/configurator/cards/edgeAutoSelect.ts": "./src/v2/configurator/cards/edgeAutoSelect.ts",
	"./v2/configurator/cards/edgeAvailability.ts": "./src/v2/configurator/cards/edgeAvailability.ts",
	"./v2/configurator/cards/edgeKeys.ts": "./src/v2/configurator/cards/edgeKeys.ts",
	"./v2/configurator/cards/enumOptions.ts": "./src/v2/configurator/cards/enumOptions.ts",
	"./v2/i18n/index.ts": "./src/v2/i18n/index.ts",
	"./v2/i18n/translateElementName.ts": "./src/v2/i18n/translateElementName.ts",
	"./v2/layout/unified/interestDraft.ts": "./src/v2/layout/unified/interestDraft.ts",
	"./v2/parametersProcessor/buildOrder.ts": "./src/v2/parametersProcessor/buildOrder.ts",
	"./v2/parametersProcessor/mergeIndexedWrappers.ts": "./src/v2/parametersProcessor/mergeIndexedWrappers.ts",
	"./v2/parametersProcessor/paramAccess.ts": "./src/v2/parametersProcessor/paramAccess.ts",
	"./v2/parametersProcessor/paramBounds.ts": "./src/v2/parametersProcessor/paramBounds.ts",
	"./v2/parametersProcessor/paramDefaults.ts": "./src/v2/parametersProcessor/paramDefaults.ts",
	"./v2/parametersProcessor/paramEffects.ts": "./src/v2/parametersProcessor/paramEffects.ts",
	"./v2/parametersProcessor/paramGuards.ts": "./src/v2/parametersProcessor/paramGuards.ts",
	"./v2/parametersProcessor/paramItems.ts": "./src/v2/parametersProcessor/paramItems.ts",
	"./v2/parametersProcessor/paramVisibility.ts": "./src/v2/parametersProcessor/paramVisibility.ts",
	"./v2/unityView/transport/IUnityTransport.ts": "./src/v2/unityView/transport/IUnityTransport.ts",
	"./v2/unityView/transport/UnityEditorTransport.ts": "./src/v2/unityView/transport/UnityEditorTransport.ts",
	"./v2/unityView/transport/unityEditorMode.ts": "./src/v2/unityView/transport/unityEditorMode.ts",
	"./v2/unityView/viewOptions.ts": "./src/v2/unityView/viewOptions.ts",
	"./v2/unityView/visibilityLayers.ts": "./src/v2/unityView/visibilityLayers.ts",
	"./zones/CabinetZoneConfigurator.ts": "./src/zones/CabinetZoneConfigurator.ts",
	"./zones/DrawerZone.ts": "./src/zones/DrawerZone.ts",
	"./zones/HorizontalDivider.ts": "./src/zones/HorizontalDivider.ts",
	"./zones/ShelfZone.ts": "./src/zones/ShelfZone.ts",
	"./zones/Space.ts": "./src/zones/Space.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive (?<%21\\.d)\\.ts$";